import { render, staticRenderFns } from "./EntomologicalMonitoring.vue?vue&type=template&id=4ca3d3fe&"
import script from "./EntomologicalMonitoring.vue?vue&type=script&lang=js&"
export * from "./EntomologicalMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./EntomologicalMonitoring.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports